import KeepAlive from "react-activation"
import { useLocation } from "react-router-dom"
import { SActionBtn, SBack, SLowcodeList, SMessage, STableActions } from "shj-components"
import config from './config.json';
import { useRef, useState } from "react";
import { Select, message, Tooltip } from 'antd'
import AddAndEdit from "./addAndEdit";
import { evaluationConfigList, evaluationDisable, evalutionConfigCopy } from "@/services/evaluateConfig";
import { httpDictServ } from "@/services/customerServices";
import { getEnums } from "@/services/homeService";
import dayjs from 'dayjs'
import { isArray } from 'lodash-es'
const EvalutionConfig = () => {
    const { Option } = Select;
    const listRef = useRef<any>();
    const [detailInfo, setDetailInfo] = useState<any>();
    const [evaluationServiceTypeList, setEvaluationServiceTypeList] = useState([]);
    const [pushConditionsList, setPushConditionsList] = useState([]);
    const [visibleDrawer, setVisibleDrawer] = useState(false);
    const [deliveryModelList, setDeliveryModelList] = useState([])//交付模式
    const fetchList = (values: any) => {
        return new Promise(async (resolve, reject) => {
            try {
                const { current, pageSize, query, ...rest } = values;
                const orderBys = [
                    {
                        "columnName": "id",
                        "asc": false
                    }
                ];
                const dataQuery = { queryEvaluationDimensionDesc: true, queryQuestion: true, orderBys, ...query }
                evaluationConfigList(current, pageSize, dataQuery).then(data => {
                    resolve(data)
                })
            } catch (e) {
                reject({ success: false });
            }
        });
    };
    const onAdd = () => {
        setDetailInfo({})
        setVisibleDrawer(true)
    }
    const toEdit = (value) => {
        setDetailInfo(value)
        setVisibleDrawer(true)
    }
    const closeDetails = () => {
        setVisibleDrawer(false)
    }
    const reloadList = () => {
        listRef.current?.reload()
    }
    const getStatusOptions = () => {
        return new Promise(async (resolve) => {
            try {
                // 服务类型列表
                const evaluationServiceTypeList: any = await httpDictServ({ parentKey: 'evaluationServiceType', enable: 1, });
                setEvaluationServiceTypeList(evaluationServiceTypeList);
                // 状态枚举
                const evaluationStatus: any = await getEnums("plus-member", "com.shj.saas.plus.member.enums.EvaluationStatus");

                // 交付模式
                const deliveryModelList: any = await getEnums("plus-member", "com.shj.saas.pms.enums.project.DeliveryMode");
                setDeliveryModelList(deliveryModelList)
                resolve({
                    evaluationStatus
                });
            } catch (e) { }
        });
    };
    const changeStatus = (record) => {
        SMessage.confirm({
            title: `是否${record.statusDesc == '启用' ? '停用' : '启用'}当前配置？`,
            okText: '确认',
            content: `确认${record.statusDesc == '启用' ? '停用' : '启用'}当前配置?`,
            cancelText: '取消',
            onOk: async () => {
                const submitStatus = record.statusDesc == '启用' ? 'deactivated' : 'enabled';
                return evaluationDisable(record.id, submitStatus).then((res: any) => {
                    message.success('提交成功');
                    listRef.current?.reload()
                })
            },
        });
    };
    const onCopy = (id) => {
        SMessage.confirm({
            title: `是否复制当前配置？`,
            okText: '确认',
            content: '确认复制此数据?',
            cancelText: '取消',
            onOk: async () => {
                return evalutionConfigCopy(id).then((res: any) => {
                    message.success('复制成功');
                    listRef.current?.reload()
                })
            },
        });
    };

  const renderList = (
    list: any[],
    getText: (item: any, index: number) => string,
    withTooltip = false
  ) => {
    if (!Array.isArray(list)) return <></>;
    return (
      <>
        {list.map((item, index) => {
          const text = getText(item, index);
          const content = (
            <div
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                cursor: withTooltip ? 'pointer' : 'default',
              }}
            >
              {text}
            </div>
          );
          return withTooltip ? (
            <Tooltip key={index} placement="topLeft" title={text}>
              {content}
            </Tooltip>
          ) : (
            <div key={index}>{text}</div>
          );
        })}
      </>
    );
  };

    const extension = {
        request: { fetchList, getStatusOptions },
        events: { onAdd },
        searchFormConfig: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        },
        customRender: {
            deliveryModelRender(_text: any, record: any) {
              return <>{deliveryModelList?.find((i: any) => i?.key === record?.deliveryModel)?.description || '-'}</>;
            },
            questionNameRender(_text, record: any) {
                return renderList(
                  record?.questionList,
                  (item, i) => `${i + 1}.${item?.questionName || ''}`,
                  true
                );
            },
            pushValidityPeriodRender(_text, record: any) {
              const start = record?.pushValidityPeriodStart
                ? dayjs(record.pushValidityPeriodStart).format('YYYY-MM-DD HH:mm:ss')
                : '-';
              const end = record?.pushValidityPeriodEnd
                ? dayjs(record.pushValidityPeriodEnd).format('YYYY-MM-DD HH:mm:ss')
                : '-';

              return <div>{`${start} ~ ${end}`}</div>;
            },
            evaluationDimensionDescRender(_text, record: any) {
              return renderList(
                record?.questionList,
                (item, i) => `${i + 1}.${item?.evaluationDimensionDesc || ''}`,
                true
              );
            },
            pushDemandTypesDescRender(_text, record: any) {
              const list = Array.isArray(record?.pushDemandTypesDesc) ? record.pushDemandTypesDesc : []
              return <>{list.length ? list.join('，') : ''}</>
            },
            indexDimensionRender(_text: any, record: any) {
              return renderList(
                record?.questionList,
                (item, i) => `${i + 1}.${item?.sourceMetricsObj?.metricsCategoryName || ''}`,
                true
              );
            },
            typeRender(_text: any, record: any) {
              return renderList(
                record?.questionList,
                (item, i) => `${i + 1}.${item?.typeName || ''}`,
                true
              );
            },
            evaluationServiceTypeRender({ key, name, form }: any) {
                return (
                    <Select
                        showSearch
                        allowClear={true}
                        filterOption={(input: any, option: any) => {
                            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                        }}
                        onChange={(value) => {
                            form.setFieldsValue({
                                [name]: value,
                            });
                            httpDictServ({ parentKey: value, enable: 1, }).then((res: any) => {
                                setPushConditionsList(res);
                            })
                        }}
                    >
                        {(evaluationServiceTypeList || []).map((item: any, i: any) => {
                            return (
                                <Option key={i} value={item.priKey}>
                                    {item.name}
                                </Option>
                            );
                        })}
                    </Select>
                );
            },
            pushConditionsRender({ key, name, form }: any) {
                return (
                    <Select
                        showSearch
                        allowClear={true}
                        filterOption={(input: any, option: any) => {
                            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                        }}
                        onChange={(value) => {
                            form.setFieldsValue({
                                [name]: value,
                            });
                        }}
                    >
                        {(pushConditionsList || []).map((item: any, i: any) => {
                            return (
                                <Option key={i} value={item.priKey}>
                                    {item.description}
                                </Option>
                            );
                        })}
                    </Select>
                );
            },
            setAction(_text: any, record: any) {
                return <STableActions>
                    {record.status != 'enabled' &&
                    <SActionBtn
                        auth={'evalutionConfigEdit'}
                        onClick={() => {
                            toEdit(record);
                        }}
                    >
                        编辑
                    </SActionBtn>}
                    <SActionBtn
                        auth={'evalutionConfigCopy'}
                        onClick={() => onCopy(record.id)}
                    >
                        复制
                    </SActionBtn>
                    <SActionBtn
                        auth={'evalutionConfigStatus'}
                        danger
                        onClick={() => changeStatus(record)}>
                        {record.statusDesc == '启用' ? '停用' : '启用'}
                    </SActionBtn>
                </STableActions>;
            },
        },
    };
    return <>
        <SBack title={`评价配置`}></SBack>
        <SLowcodeList
            config={config}
            ref={listRef} {...extension} searchMode="group" />
        <AddAndEdit record={detailInfo} visibleDrawer={visibleDrawer} closeDetails={closeDetails} reloadList={reloadList}></AddAndEdit>
    </>
}
export default (props: any) => {
    const location = useLocation()
    return (
        <KeepAlive name={location.pathname} id={'keep' + location.pathname}>
            <EvalutionConfig {...props} />
        </KeepAlive>
    )
}
